export enum CallbackUrlStatus {
  InProgress = 'in_progress',
  Success = 'success',
  Error = 'error',
}
